import { Base } from '@studiometa/js-toolkit';

/**
* StickyHeader component
*/
export default class StickyHeader extends Base {
    isSticky = false;

    /**
    * Component Configuration
    */
    static config = {
        name: 'StickyHeader',
        refs: ['wrapper'],
    };

    /**
    *
    */
    mounted() {
        document.documentElement.style.setProperty('--header-height', `${this.$el.offsetHeight}px`);

        if (window.scrollY > 100) {
            document.body.classList.add('is-sticky');
        }
    }

    /**
    *
    */
    resized() {
        document.documentElement.style.setProperty('--header-height', `${this.$el.offsetHeight}px`);
    }

    /**
    * Service scrolled hook
    * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
    * @param {object} props Props
    * @param {number} props.y The current vertical scroll position.
    * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
    */
    scrolled({ y, direction }) {

        const header = this.$el.closest('header');

        if (y > 150 && !this.isSticky) {
            document.body.classList.add('is-sticky');
            this.isSticky = true;
        }
        if (y < 50 && this.isSticky) {
            document.body.classList.remove('is-sticky');
            this.isSticky = false;
        }
        if (direction.y === 'NONE') {
            return;
        }
        if (y > 150) {
            if (direction.y === 'DOWN' && !document.body.classList.contains('menu-is-open')) {
              header.classList.add('-tw-translate-y-full');
                // this.$el.classList.remove('tw-top-0');
            }
            if (direction.y === 'UP') {
              header.classList.remove('-tw-translate-y-full');
                // this.$el.classList.add('tw-top-0');
            }
        }
    }
}
